document.querySelectorAll('.collection__filter .filter-menu__item').forEach(function(item) {
    item.addEventListener('click', function() {
        item.parentElement.querySelectorAll('.filter-menu__item').forEach(function(sibling) {
            sibling.classList.remove('active');
        });
        
        item.classList.add('active');
        
        let parentFilter = item.closest('.collection__filter');
        parentFilter.querySelector('h4').textContent = item.textContent;
        parentFilter.querySelector('h4').classList.add('active');
        
        let activeFilters = {};
        let activeFiltersList = [];

        document.querySelectorAll('[data-og-title]').forEach(function(element) {
            const title = element.getAttribute('data-og-title').trim();
            if (!activeFilters[title]) {
                activeFilters[title] = [];
            }
        });

        document.querySelectorAll('.collection__filter').forEach(function(filterElement) {
            let activeItem = filterElement.querySelector('.filter-menu__item.active');
            if (activeItem) {
                let filtertype = filterElement.querySelector('[data-og-title]').getAttribute('data-og-title').trim();
                let filterItem = activeItem.getAttribute('data-filter');
                activeFilters[filtertype].push(filterItem);
                activeFiltersList.push(filterItem);
            }
        });

 document.querySelectorAll('.collection__item').forEach(function(product) {
    let productModel = product.getAttribute('data-model') || '';
    let productOptions = product.getAttribute('data-options') || '';
    let variantMetafield = product.getAttribute('data-variant-metafield') || '';
    let productTag = product.getAttribute('data-tag') || '';

    // Helper function to check if any active filter matches the product attribute
    function matchesFilter(activeFilterArray, productAttribute) {
        // If the filter array is empty, return false
        if (activeFilterArray.length === 0) {
            return false;
        }
        // Check if productAttribute contains any of the active filters
        return productAttribute.length > 0 && activeFilterArray.some(filter => productAttribute.includes(filter));
    }

    // Check filters against product attributes
    let containsModel = (activeFilters.Watches && activeFilters.Watches.length > 0) ? matchesFilter(activeFilters.Watches, productModel) : true;
    let containsWidth = (activeFilters.Width && activeFilters.Width.length > 0) ? matchesFilter(activeFilters.Width, productOptions) : true;
    let containsColor = (activeFilters.Color && activeFilters.Color.length > 0) ? matchesFilter(activeFilters.Color, productOptions) : true;
    let containsType = (activeFilters.Type && activeFilters.Type.length > 0) ? matchesFilter(activeFilters.Type, productOptions) : true;
    let containsMetafield = (activeFilters.watchwidth && activeFilters.watchwidth.length > 0) ? matchesFilter(activeFilters.watchwidth, variantMetafield) : true;
    let containsTag = (activeFilters.Tag && activeFilters.Tag.length > 0) ? matchesFilter(activeFilters.Tag, productTag) : true;

    //console.log('Active Filters:', activeFilters);
    //console.log('Product Attributes:', productModel, productOptions, variantMetafield, productTag);
    //console.log(containsModel, '&&', containsWidth, "&&", containsColor, "&&", containsType, "&&", containsMetafield, "&&", containsTag);

    // AND logic to check for all the qualifiers
    if (containsModel && containsWidth && containsColor && containsType && containsMetafield && containsTag) {
        product.style.display = 'block';
        product.classList.add('active');
    } else {
        product.style.display = 'none';
        product.classList.remove('active');
        //console.log('NOOOO');
    }
});


    // Show all items if no filters are active
  if (activeFiltersList.length <= 0) {
  document.querySelectorAll('.collection__item').forEach(function(item) {
      item.style.display = 'block';
      item.classList.add('active');
  });
  }

  // Handle subcollection visibility based on active collection items
  document.querySelectorAll('.subcollection').forEach(function(subcollection) {
  // Check if there are any active items in the current subcollection
  let activeItems = subcollection.querySelector('.grid--flex').querySelectorAll('.collection__item.active');

  // If no active items inside the subcollection, hide it
  if (activeItems.length === 0) {
      subcollection.style.display = 'none';
  } else {
      // Otherwise, show the subcollection
      subcollection.style.display = 'block';
  }
  });


        if (!document.querySelector('.collection__filter-clear').style.display || document.querySelector('.collection__filter-clear').style.display === 'none') {
            document.querySelector('.collection__filter-clear').style.display = 'block';
        }
    });
});

document.querySelector('.collection__filter-clear').addEventListener('click', function() {
    this.style.display = 'none';
    document.querySelectorAll('.collection__filter h4').forEach(function(header) {
        header.textContent = header.getAttribute('data-og-title');
    });
    document.querySelectorAll('.filter-menu__item').forEach(function(item) {
        item.classList.remove('active');
    });
    document.querySelectorAll('.collection__filter h4').forEach(function(header) {
        header.classList.remove('active');
    });
    document.querySelectorAll('.subcollection').forEach(function(subcollection) {
        subcollection.style.display = 'block';
    });
    document.querySelectorAll('.collection__item').forEach(function(item) {
        item.classList.add('active');
        item.style.display = 'block';
    });
});

document.querySelectorAll('.collection__filter').forEach(function(filterElement) {
    filterElement.addEventListener('mouseenter', function() {
        if (window.innerWidth > 750) {
            filterElement.classList.add('active');
            filterElement.querySelector('.collection__filter-title .icon').classList.remove('icon-chevron-right');
            filterElement.querySelector('.collection__filter-title .icon').classList.add('icon-x');
            //filterElement.querySelector('.collection__filter-title .icon.icon-chevron-right').style.visibility = 'hidden';
            //filterElement.querySelector('.collection__filter-title .icon.icon-chevron-right').style.opacity = '0';
            //filterElement.querySelector('.collection__filter-title .icon.icon-x').style.visibility = 'visible';
            //filterElement.querySelector('.collection__filter-title .icon.icon-x').style.opacity = '1';
          //  filterElement.querySelector('.collection__filter-title .icon.icon-chevron-right').style.display = 'none';
          //  filterElement.querySelector('.collection__filter-title .icon.icon-x').style.display = 'block';

        }
    });

    filterElement.addEventListener('mouseleave', function() {
        if (window.innerWidth > 750) {
            filterElement.classList.remove('active');
            filterElement.querySelector('.collection__filter-title .icon').classList.remove('icon-x');
            filterElement.querySelector('.collection__filter-title .icon').classList.add('icon-chevron-right');
           // filterElement.querySelector('.collection__filter-title .icon.icon-chevron-right').style.visibility = 'visible';
           // filterElement.querySelector('.collection__filter-title .icon.icon-chevron-right').style.opacity = '1';
           // filterElement.querySelector('.collection__filter-title .icon.icon-x').style.visibility = 'hidden';
            //filterElement.querySelector('.collection__filter-title .icon.icon-x').style.opacity = '0';
           //  filterElement.querySelector('.collection__filter-title .icon.icon-chevron-right').style.display = 'block';
          //  filterElement.querySelector('.collection__filter-title .icon.icon-x').style.display = 'none';
        }
    });
});

document.querySelectorAll('.collection__filter .collection__filter-title').forEach(function(titleElement) {
    titleElement.addEventListener('click', function() {
        let filterElement = titleElement.parentElement;
        if (filterElement.classList.contains('active')) {
            filterElement.classList.remove('active');
            titleElement.querySelector('.icon').classList.remove('icon-x');
            titleElement.querySelector('.icon').classList.add('icon-chevron-right');
        } else {
            document.querySelectorAll('.collection__filter').forEach(function(filter) {
                filter.classList.remove('active');
                filter.querySelector('.collection__filter-title .icon').classList.remove('icon-x');
                filter.querySelector('.collection__filter-title .icon').classList.add('icon-chevron-right');
            });
            filterElement.classList.add('active');
            titleElement.querySelector('.icon').classList.remove('icon-chevron-right');
            titleElement.querySelector('.icon').classList.add('icon-x');
        }
    });
});



 document.addEventListener('mouseup', function(e) {
    if (document.querySelector('.collection__filters')) {
        if (!e.target.closest('.collection__filter .collection__filter-title')) {
          //console.log('test');
            document.querySelectorAll('.collection__filter').forEach(function(filterElement) {
                filterElement.classList.remove('active');
                filterElement.querySelector('.icon').classList.remove('icon-x');
                filterElement.querySelector('.icon').classList.add('icon-chevron-right');
            });
        }
    }
}); 
document.addEventListener('click', function(event) {
    if (!event.target.closest('.collection__filter')) {
        document.querySelectorAll('.collection__filter').forEach(function(filterElement) {
            filterElement.classList.remove('active');
            filterElement.querySelector('.icon').classList.remove('icon-x');
            filterElement.querySelector('.icon').classList.add('icon-chevron-right');
        });
    }
});

document.querySelectorAll('.filter-menu__item').forEach(function(item) {
    item.addEventListener('click', function() {
        document.querySelectorAll('.collection__filter').forEach(function(filterElement) {
            filterElement.classList.remove('active');
            filterElement.querySelector('.icon').classList.remove('icon-x');
            filterElement.querySelector('.icon').classList.add('icon-chevron-right');
        });
    });
});